<template>
    <div>
        <div class="row mt-5">
            <div class="col-12 col-lg-6">
                <div class="box p-3">
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-primary float-end" @click="AddNewLink">
                                <span> New Link </span>
                            </button>
                        </div>
                    </div>
                    <hr>
                    <div class="row mt-3" v-for="gallery in accomodation_images" :key="gallery.id">
                        <div class="col-md-12">
                            <div class="form-group">
                              <label for="" class="form-label"> Accommodation Image Link {{ gallery.id }}</label>
                              <input type="text" class="form-control" name="" id="" aria-describedby="helpId" placeholder="Link" v-model="gallery.link">
                            </div>
                        </div>
                    </div>
                    <small v-if="accomodation_images_error" class="text-danger">{{ accomodation_images_error }}</small>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <button type="submit" class="button" @click="LinkAccommodationImages"><span> Add Gallery Image </span></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="box mt-5 p-3" v-if="added_images && added_images.length > 0">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4 mt-3" v-for="image in added_images" :key="image.id">
                    <div class="card card-shadow">
                        <img class="card-img-top image_block" :src="image.link" alt="Card image cap">
                        <div class="card-body">
                            <button type="button" class="btn btn-outline-danger float-end" @click="deleteAccomodationImages(image.id)">
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                                    <path d="M 10 2 L 9 3 L 5 3 C 4.4 3 4 3.4 4 4 C 4 4.6 4.4 5 5 5 L 7 5 L 17 5 L 19 5 C 19.6 5 20 4.6 20 4 C 20 3.4 19.6 3 19 3 L 15 3 L 14 2 L 10 2 z M 5 7 L 5 20 C 5 21.1 5.9 22 7 22 L 17 22 C 18.1 22 19 21.1 19 20 L 19 7 L 5 7 z M 9 9 C 9.6 9 10 9.4 10 10 L 10 19 C 10 19.6 9.6 20 9 20 C 8.4 20 8 19.6 8 19 L 8 10 C 8 9.4 8.4 9 9 9 z M 15 9 C 15.6 9 16 9.4 16 10 L 16 19 C 16 19.6 15.6 20 15 20 C 14.4 20 14 19.6 14 19 L 14 10 C 14 9.4 14.4 9 15 9 z"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box mt-5 p-5" v-else>
            <div class="row p-3">
                <img src="../../assets/img/undraw_empty_re_opql.svg" alt="" srcset="" height="300px">
            </div>
            <div class="row mt-3">
                <div class="col-md-12 text-center">
                    <h3>No Gallery Images Found</h3>
                </div>
            </div>
        </div>
</div>
</template>

<script>
export default {
    name: 'AccomodationGallery',
    props: {
        accommodation: Object,
        added_images:Array
    },
    data() {
        return {
            accomodation_images: [
                {
                    id: 1,
                    link:null
                }
            ],
            accomodation_images_error:null,
            getLoadStatus:false
        }
    },
    methods: {
        AddNewLink() {
            let newLinkObject = {
                id: this.accomodation_images.length + 1,
                link:null
            }

            this.accomodation_images.push(newLinkObject)
        },
        LinkAccommodationImages() {
            let addedAccomodationImages = this.accomodation_images.filter(obj => obj.link !== null && obj.link !== '')
            if (addedAccomodationImages.length > 0) {
                this.accomodation_images_error = null
                let url = `${this.$api}accommodation/handle-gallery`
                let body = {
                    accommodation_id:this.accommodation.id,
                    image_links:addedAccomodationImages
                }
                this.handleAccomodationImages(url,body)
            } else {
                this.accomodation_images_error = "Please provide atleast one link."
            }
        },
        deleteAccomodationImages(image_path_id) {
            let url = `${this.$api}accommodation/delete-gallery-image`
            let body = {
                accommodation_id:this.accommodation.id,
                image_links_id:image_path_id
            }
            this.handleAccomodationImages(url,body)
        },
        handleAccomodationImages(url,body) {
            this.$store.dispatch('setLoadStatus')
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                if(response.status) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                    this.accomodation_images = [{ id: 1, link: null }]
                    this.$emit('updateAccomodation')
                } else if (response.errors) {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
                this.$store.dispatch('setLoadStatus')
            });
        }
    }        
}
</script>

<style lang="scss" scoped>
.image_block {
    height: 297px;
    width: auto;
    object-fit: cover;
}
.card-shadow {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}



</style>